import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const DataSecurity = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M27 10C26.667 10 26.331 9.971 26 9.921V7C26 5.346 24.654 4 23 4H7C5.346 4 4 5.346 4 7V11C4 11.768 4.29 12.469 4.766 13C4.29 13.531 4 14.232 4 15V19C4 20.654 5.346 22 7 22H14.637C16.241 25.697 20.338 27.787 20.553 27.894C20.694 27.964 20.847 28 21 28C21.153 28 21.306 27.965 21.447 27.894C21.714 27.76 28 24.554 28 19V11C28 10.448 27.552 10 27 10ZM6 7C6 6.449 6.449 6 7 6H23C23.551 6 24 6.449 24 7V9.38C22.6 8.853 21.571 8.178 21.555 8.168C21.22 7.945 20.782 7.945 20.447 8.167C20.419 8.185 17.652 10 15.001 10C14.449 10 14.001 10.448 14.001 11V12H7.001C6.45 12 6.001 11.551 6.001 11V7H6ZM7 20C6.449 20 6 19.551 6 19V15C6 14.449 6.449 14 7 14H14V19C14 19.342 14.024 19.676 14.069 20H7V20ZM26 19C26 22.57 22.303 25.081 21 25.855C19.696 25.081 16 22.57 16 19V11.939C18.129 11.684 20.078 10.7 21 10.171C21.922 10.7 23.871 11.684 26 11.939V19Z" />
		<path d="M10 17C10 17.552 9.552 18 9 18C8.448 18 8 17.552 8 17C8 16.448 8.448 16 9 16C9.552 16 10 16.448 10 17Z" />
		<path d="M10 9C10 9.552 9.552 10 9 10C8.448 10 8 9.552 8 9C8 8.448 8.448 8 9 8C9.552 8 10 8.448 10 9Z" />
	</svg>
);

export default DataSecurity;
